/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Scratch 2.0",
  "description": "Scratch 2.0 Preset for Permafy.",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [
    "danger"
  ],
  "enabledByDefault": false
};
export default manifest;